import React, { useEffect } from 'react';
import StepsViewer from './StepsViewer';
import {
  setSteps,
  setConfig,
  setLoading
} from '../../../redux/walkthroughPreviewSlice';
import { API_ENDPOINTS } from '../utils/endpoints';
import { useDispatch } from 'react-redux';
import { http_get } from '../../pages/utils/api_client';
import { fetchCompanyDetails } from '../../../redux/companySlice';
import { setMaterial } from '../../../redux/materialSlice';

const EditorPreview = ({ id }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true));
    const url = `${API_ENDPOINTS.GET_LEARNING_MATERIALS}/${id}`;

    // Load company details so the learner top nav can render the brand name /
    // logo (StepsViewer falls back to these when there's no hub session).
    dispatch(fetchCompanyDetails());

    http_get(url)
      .then((response) => {
        const config = response.data.config;
        const steps = response.data.data;
        // Also store the material so the learner top nav can show the
        // walkthrough title (name) next to the logo.
        dispatch(setMaterial(response.data));
        // Content-aware browser tab: reflect the walkthrough's name.
        if (response.data && response.data.name) {
          document.title = `${response.data.name} · UserNurture`;
        }
        dispatch(setSteps(steps));
        dispatch(setConfig(config));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  }, []);

  return (
    <>
      <StepsViewer />
    </>
  );
};

export default EditorPreview;
